"use client"

import { NotAppliedError } from "../lib/pointsAPI"
import { getPromotionStanding } from "../lib/promotionStanding"
import { useOptInStatus, useStats } from "./usePointsQueries"

export function usePromotionStanding(accountId: string | undefined) {
  const optInQuery = useOptInStatus(accountId)
  const hasApplied = optInQuery.data?.status === "applied"
  const statsQuery = useStats(accountId, { enabled: hasApplied })

  return {
    standing: getPromotionStanding({
      accountId,
      optInStatus: optInQuery.data,
      optInLoading: optInQuery.isLoading,
      optInError: optInQuery.isError,
      stats: statsQuery.data,
      statsLoading: statsQuery.isLoading,
      statsError: statsQuery.isError,
      statsNotApplied: statsQuery.error instanceof NotAppliedError,
    }),
    refetchOptInStatus: optInQuery.refetch,
  }
}
